import * as React from 'react';
import axios from 'axios';
import RenderShareCart from './RenderShareCart';
import { Cart,ItemCart } from './iCart';
import RenderItemsCart from './RenderItemsCart';

import Icons from '../mon-compte/Icons';

import {
  applyShare,
  getCart,
  getCartId,
  getShopInfos,
  getUrlParameter,
  updatePiwik,
} from './CartAction';
import cartStore from './CartStore';
import { RenderOptionsCart } from './RenderOptionsCart';
import { RenderLegendCart } from './RenderLegendCart';
import RenderMontantsCart from './RenderMontantsCart';
import { RenderFrancoPort } from './RenderFrancoPort';

import { PaypalCheckout } from '../payment/PaypalCheckout';

import { getShopRefInStorage, sessionExpire } from '../mon-compte/MonCompteAction';
import { getShopInfosInStorage } from './ShopInfos';
import {checkBlacklist, checkStock, getHostApi, getRequestConfig, getShopInfo, scrollTo} from '../../utils';
import { BlackListError, StockErrors } from './cartInterfaces';
import { TranslationProps, WithTranslation } from "../../contexts/TranslationContext";
import {PaypalCheckoutV2} from "../payment/PaypalCheckoutV2";
import { fetchHasFeature } from '../../service/shop.api';

//eslint-disable-next-line
declare var jQuery: any;

interface CartAppState {
  cart?: Cart;
  validerDroits?: boolean;
  paypalExpressEnable: boolean;
  francoAtteint?: boolean;
  francoNonAtteintRestant?: number;
  franco?: number;
  shippingDay?: any;
  activateMaintenance?: any;
  activateMaintenanceSite?: any;
  activateMaintenanceDG?: any;
  activateMaintenanceTO?: any;
  activateMaintenanceTE?: any;
  activateMaintenanceMT?: any;
  activateMaintenanceME?: any;
  activateRestrictionsCMJN?: any;
  activateRestrictionsCreations?: boolean;
  activateControleMinSericoat?: any;
  textMaintenance?: any;
  textNotAllowOrder?: any;
  textMinSericoat?: any;
  nbCmjnDifferents?: number;
  nbCreationsDifferentes?: number;
  nbCreationsDifferentesAvecControleQty?: number;
  ratioQtyNbCreationsDifferentes?: number;  
  minQtyToAdd?: number;
  nbrCmjnTopquadri?: number;
  nbrCmjnQuadriluxe?: number;
  nbrCmjnSublimation?: number;
  nbrCmjnSericoat?: number;
  nbrCmjnBroderie?: number;
  allowOrder?: boolean;
  allowSerigraphie?: boolean;
  allowCreations?: boolean;
  allowCreationsQtyControle?: boolean;
  qteMinSericoat?: number;
  itemProblemeSerigraphie?: [];
  stockErrors: StockErrors;  
  maxLinesInCart?: boolean;
  maxLinesQtyInCart?: number;
  blacklistError: BlackListError;
  isModeHT: boolean; // Si true, Affiche en HT les prix
  countryDelivery?: string | null;
  applyIsProgress: boolean; // Permet de savoir si une requête d'application d'un panier partagé est en cours
  enabledFeatureOrderDelayType: boolean;
}

class CartApp extends React.Component<TranslationProps, CartAppState> {

  private cartShared: boolean = false;

  constructor(props: TranslationProps) {
    super(props);
    this.cartShared = false;
    const isModeHT = JSON.parse(localStorage.getItem('excludedTax') ?? 'true');
    this.state = {
      paypalExpressEnable: false,
      allowOrder: true,
      allowSerigraphie: true,
      allowCreations: true,
      allowCreationsQtyControle: true,
      maxLinesInCart: false,
      stockErrors: {valid: true, errorItems: null},
      blacklistError: {valid: true, errorItems: []},
      isModeHT,
      applyIsProgress: false,
      countryDelivery:  localStorage.getItem('countryDelivery') ?? null,
      franco: getShopInfosInStorage() && getShopInfosInStorage().franco ? getShopInfosInStorage().franco : undefined,
      enabledFeatureOrderDelayType: false
    };
  }

  /**
   * Fonction mettant à jour le state validerDroits
   */
  onValiderDroits = (droits: boolean) => {
    this.setState({
      validerDroits: droits,
    });
  }

  fetchFranco = () => {
    const shopInfos = getShopInfosInStorage();
    const tvaTaux =  (this.state.cart && this.state.cart?.montants?.taux_tva) ?? null;
    if (!shopInfos) {
      return ;
    } else if(tvaTaux === null && shopInfos.franco ) {
      return shopInfos.franco;
    }
    let francoValueHt = shopInfos?.franco;
    if(!this.state.isModeHT && tvaTaux){
      francoValueHt = francoValueHt * (1 + tvaTaux / 100);
    }
    return francoValueHt;
  }

  /**
   * Fonction permettant de checker si le franco de port est atteint
   * @returns {boolean}
   */
  checkFranco = () => {
    if (this.state.franco && this.state.franco > 0) {
      let reste = 0;
      if (Number(this.state.cart?.montants.ht_sans_remise.toFixed(2)) >= this.state.franco) {
        this.setState(
          { francoNonAtteintRestant: reste, francoAtteint: true  }
        );
      }
      if (Number(this.state.cart?.montants.ht_sans_remise.toFixed(2)) < this.state.franco) {
        reste = this.state.franco - (this.state.cart?.montants.ht_sans_remise as number);
        
        if(!this.state.isModeHT && this.state.cart?.montants?.taux_tva){
          reste = reste * (1 + this.state.cart?.montants?.taux_tva / 100);
        }
        this.setState(
          { francoNonAtteintRestant: reste, francoAtteint: false }
        );
      }
    } else {
      return;
    }
  }

  componentDidMount() {
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('onCartCreate', () => {
        getShopInfos();
        getCart();
        this._getMaintenanceSites();
        this._getMaintenanceSite(getShopRefInStorage());
        this._getRestrictionNbCmjnDifferents();
        this._getControleMinSericoat();
        this._getRestrictionNbCreationsDifferents();
      });
    }
    getShopInfos();
    getCart();
    this._getNbMaxLinesPanier();
    this._getMaintenanceSites();
    this._getMaintenanceSite(getShopRefInStorage());
    this._getRestrictionNbCmjnDifferents();
    this._getControleMinSericoat();
    this._getRestrictionNbCreationsDifferents();
    cartStore.addListener('change', this.refreshCart);
    document.body.addEventListener('onTaxSwitched', this.handleTaxChange.bind(this));
  }

  componentWillUnmount() {
    cartStore.removeListener('change', this.refreshCart);
    document.body.removeEventListener('onTaxSwitched', this.handleTaxChange.bind(this));
  }

  handleTaxChange = () => {
    const newIsModeHT = JSON.parse(localStorage.getItem('excludedTax') ?? 'true');
    const newFrancoValue = this.fetchFranco();    
    this.setState({ franco: newFrancoValue, isModeHT: newIsModeHT }, () => {
      this.checkFranco();
    });
  }

  _getShippingDay = () => {
    if (!getCartId()) {
      return;
    }

    axios.get(`${getHostApi()}/carts/` + getCartId() + '/shipping-day', getRequestConfig()).then((response) => {
      if (response.data.shippingDay) {
        this.setState({
          shippingDay: response.data.shippingDay,
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  _getItemsNotAllowedSeriCoat = () => {
    const idSeriCoat = 3;
    if (!getCartId()) {
      return;
    }
    axios.get(`${getHostApi()}/carts/${getCartId()}/items-not-allowed-by-marking/${idSeriCoat}`, getRequestConfig()).then((response) => {
      if (response.data) {
        if(response.data.length > 0) {
          this.setState({
            allowSerigraphie: false,
            itemProblemeSerigraphie: response.data,
          });
        } else {
          this.setState({
            allowSerigraphie : true,
            itemProblemeSerigraphie: [],
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  _getMaintenanceSites() {
    fetchHasFeature('tunnel_maintenance_tous_les_sites')
      .then(response => {
        this.setState({ activateMaintenance: response.data.feature }, () => {
          this._getTexteMaintenanceSite();
        });
      })
  }

  _getMaintenanceSite(boutique: string) {
    fetchHasFeature(`tunnel_maintenance_${boutique.toLowerCase()}`)
      .then((response) => {
        this.setState({ activateMaintenanceSite: response.data.feature }, () => {
          this._getTexteMaintenanceSite();
        });
      })
  }

  _getRestrictionNbCmjnDifferents() {
    fetchHasFeature('panier_cmjn_maximum_par_techniques')
      .then((response) => {
        this.setState({ activateRestrictionsCMJN: response.data.feature }, () => {
          this._getTexteNbrCouleursMax();
          this._getNbCmjnDifferents();
        });
      });
  }
  
  _getRestrictionNbCreationsDifferents() {
    fetchHasFeature('panier_creations_limite')
      .then((response) => {
        this.setState({ activateRestrictionsCreations: response.data.feature }, () => {
          this._getNbCreationsDifferentes();
        });
      });
  }

  _getControleMinSericoat() {
    const shopInfos = getShopInfosInStorage();
    if (!shopInfos) {
      return;
    }
    const qteMin = parseInt(shopInfos['qte_min_marquage']['tarif_qte_min_serigraphie']);
    if (shopInfos['sericoat_sans_minimum']) {
      this.setState({ activateControleMinSericoat: shopInfos['sericoat_sans_minimum'], qteMinSericoat: qteMin, textMinSericoat: 'La quantité de vos articles en marquage SeriCoat est inférieure au seuil autorisé de ' + qteMin + ' pièces pour une même surface de marquage'});
    }
  }


  _getTexteMaintenanceSite() {
    axios.get(`${getHostApi()}/shops/variables/activation_maintenance_tunnel_texte`, getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ textMaintenance: response.data.variable['valeur'] });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getTexteNbrCouleursMax() {
    axios.get( getHostApi() + '/shops/variables/restrictions_couleurs_cmjn_panier_texte', getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ textNotAllowOrder: response.data.variable['valeur'] });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getNbCmjnDifferents() {
    axios.get(getHostApi() + '/shops/variables/restrictions_couleurs_cmjn_maximum_panier', getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ nbCmjnDifferents: response.data.variable['valeur'] });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getNbCreationsDifferentes() {
    axios.get(getHostApi() + '/shops/variables/restrictions_creations_maximum_panier', getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ nbCreationsDifferentes: response.data.variable['valeur'] });
        this._getNbCreationsDifferentesAvecControleQty();
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getNbCreationsDifferentesAvecControleQty() {
    axios.get(getHostApi() + '/shops/variables/restrictions_creations_max_panier_avec_controle', getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ nbCreationsDifferentesAvecControleQty: response.data.variable['valeur'] });
        this._getQtyMinPanierSiCreationsDifferentes();
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _getQtyMinPanierSiCreationsDifferentes() {
    axios.get(getHostApi() + '/shops/variables/restrictions_creations_controle_panier_quantitees_ratio', getRequestConfig()).then((response) => {
      if (response.data.variable) {
        this.setState({ ratioQtyNbCreationsDifferentes: response.data.variable['valeur'] });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _checkStock = async (cartId: string): Promise<boolean> => {
    let valid = true;
    try {
      await checkStock(cartId);
    } catch (e) {
      valid = false;
      this.setState({stockErrors: e as any});
      this.displayStockError(e as any);
    }
    return valid;
  };

  _checkBlacklist = async (cartId: string): Promise<boolean> => {
    let valid = true;
    const countryCode = localStorage.getItem('countryDelivery');
    if (countryCode !== null) {
      const response = await checkBlacklist(cartId, countryCode);
      this.setState({blacklistError: response});
      valid = response.valid;
      if (!response.valid) {
        const firstItem = response.errorItems[0];
        scrollTo(`cartArticleId-${firstItem.id}`);
      }
    }
    return valid;
  };  

  _getNbMaxLinesPanier() {
    axios.get(`${getHostApi()}/shops/variables/lignes_panier_max`, getRequestConfig()).then((response) => {
      if (response.data.variable) {
        const varMaxLine = parseInt(response.data.variable['valeur']) > 0 ? parseInt(response.data.variable['valeur']) : null;
        if(varMaxLine !== null) {
          this.setState({ maxLinesQtyInCart: parseInt(response.data.variable['valeur'])});
        }
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  _checkQtyLinesMax = async (cartLines: ItemCart[]): Promise<boolean> => {
    let valid = true;
    if(this.state.maxLinesQtyInCart && cartLines.length > 0) {
    valid = cartLines.length <= this.state.maxLinesQtyInCart;
    }
    this.setState({ maxLinesInCart: !valid});
    return valid;
  };
  

  /**
   * Fonction permettant de rafraichir le panier
   */
  refreshCart = () => {
    this.setState({
      cart: cartStore.getCart(),
    }, () => {
      this.updatePaypalEnable();
      this.fetchFranco();
      this.checkFranco();
      const shareToken = getUrlParameter('share');
      this._getShippingDay();
      if (shareToken && !this.cartShared) {
        this.setState({ applyIsProgress: true });
        applyShare(shareToken).finally(() => this.setState({ applyIsProgress: false }));
        this.cartShared = true;
      } else {
        updatePiwik();
      }
      if (this.state.cart) {
        if(this.state.cart.items) {
          this._checkQtyLinesMax(this.state.cart.items);
        }
        this._checkBlacklist(this.state.cart.id);
        this._checkStock(this.state.cart.id);
      }
    });
    CartApp.updateQtPanier(this.state.cart?.quantite_globale as number);
    if ((getShopInfosInStorage().Ref === 'TO' || getShopInfosInStorage().Ref === 'TE') && (this.state.activateRestrictionsCMJN || this.state.activateRestrictionsCreations)) {
      this._isAllowOrder();
    }
    if ((getShopInfosInStorage().Ref === 'TO' || getShopInfosInStorage().Ref === 'TE') && this.state.activateControleMinSericoat) {
      this._getItemsNotAllowedSeriCoat();
    }

    const shopRef = getShopRefInStorage().toLowerCase();
    if (['te', 'to'].includes(shopRef) || (shopRef === 'th' && this.state.cart?.order_delay_type_id)) {
      fetchHasFeature(`display_order_delay_type`)
        .then(response => this.setState({ enabledFeatureOrderDelayType: response.data.feature }));
    }
  }

  onCommander = () => {
    if(this.state.cart?.id) {
      Promise.all([this._checkStock(this.state.cart.id), this._checkBlacklist(this.state.cart.id)])
        .then((values) => {
          if (!values.includes(false)) {
            localStorage.setItem('hostApi', getHostApi());
            window.location.href = '/order';
          }
        });
    }
  }

  displayStockError = (stockErrors: StockErrors) => {
    const firstItem = Object.keys(stockErrors?.errorItems || {})[0];
    scrollTo(`cartArticleId-${firstItem}`);
    this.setState({stockErrors: stockErrors});
  };

  surbrillanceDroits = () => {
    document.getElementById('checkboxDroitsME')?.classList.add('surbrillanceDroits');
  }

  updatePaypalEnable = () => {
    fetchHasFeature('paiement_paypal_express')
      .then((res: any) => {
        this.setState({
          paypalExpressEnable: res.data.feature,
        });
      });
  }

  handleOnPaymentApproved = (data: any) => {
    if (this.state.cart) {
      document.dispatchEvent(new CustomEvent('dp-loading'));

      axios.post(`${getHostApi()}/carts/${this.state.cart.id}/paypal/flow/account`, { paymentID: data.paymentID, orderId: data.orderID, payerId: data.payerID }, getRequestConfig())
        .then((res: any) => {
          const cart: any = { ...this.state.cart };

          cart.shipping_address_id = res.data.address.id;
          cart.billing_address_id = res.data.address.id;
          cart.shipping_address = res.data.address;
          cart.billing_address = res.data.address;

          if (res.data.shipping_address) {
            cart.shipping_address = res.data.shipping_address;
            cart.shipping_address_id = res.data.shipping_address.id;
          }
          if (res.data.billing_address) {
            cart.billing_address = res.data.billing_address;
            cart.billing_address_id = res.data.billing_address.id;
          }

          localStorage.setItem('cartStruct', JSON.stringify({ cart }));
          sessionStorage.setItem('customerStruct', JSON.stringify(res.data.customer));
          sessionStorage.setItem('billing_address', JSON.stringify(res.data.address));
          sessionStorage.setItem('shipping_address', JSON.stringify(res.data.address));

          const shopInfo = getShopInfo();
          if(cart.montants.ttc < (shopInfo?.paypal_express_min_ttc || 50)) {
            window.location.href = '/order/shipping';
            return;
          }

          if(res.data.orderID) {
            window.location.href = '/order/shipping?orderId=' + res.data.orderID + '&payerId=' + res.data.payerID;
          } else {
            window.location.href = '/order/shipping?paymentId=' + res.data.paymentID + '&payerId=' + res.data.payerID;
          }
        }).catch((err: any) => {
        document.dispatchEvent(new CustomEvent('dp-loaded'));
        console.error(err);
      });
    }
  }

  static updateQtPanier(newQte: number) {
    const panierQt = document.getElementById('nbrProduct');
    if (panierQt) {
      panierQt.innerHTML = newQte.toString();
    }
  }

  _colorBoxWarning = () => {
    const div = document.getElementById('box-warning');
    if(div) {
      if (div.style.boxShadow == '') {
        div.style.boxShadow = '0 0 5px 1px #333';
      } else {
        div.style.boxShadow = '';
      }
    }
  }

  _isAllowOrder = () => {
    const tabTopQuadri = [];
    const tabQuadriluxe = [];
    const tabBroderie = [];
    const tabSerigraphie = [];
    const tabSublimation = [];

    const tabCreationIds: string[] = [];

    if (this.state.cart) {

      for (const item of this.state.cart.items) {
        let cmjn = '';

        if (item.article.couleur.cyan !== undefined && item.article.couleur.magenta !== undefined && item.article.couleur.jaune !== undefined && item.article.couleur.noir !== undefined) {
          cmjn = item.article.couleur.cyan + '-' + item.article.couleur.magenta + '-' +
            item.article.couleur.jaune + '-' + item.article.couleur.noir;
        }
        if (cmjn != '') {
          if (item.marquage.libelle === 'TopQuadri' && tabTopQuadri.indexOf(cmjn) === -1) {
            tabTopQuadri.push(cmjn);
          } else if (item.marquage.libelle === 'Quadriluxe'  && tabQuadriluxe.indexOf(cmjn) === -1)  {
            tabQuadriluxe.push(cmjn);
          } else if (item.marquage.libelle === 'Broderie' && tabBroderie.indexOf(cmjn) === -1) {
            tabBroderie.push(cmjn);
          } else if (item.marquage.libelle === 'SeriCoat' && tabSerigraphie.indexOf(cmjn) === -1) {
            tabSerigraphie.push(cmjn);
          } else if (item.marquage.libelle === 'Sublimation'  && tabSublimation.indexOf(cmjn) === -1) {
            tabSublimation.push(cmjn);
          }
        }
        if(item.creation_id && !tabCreationIds.includes(item.creation_id)) {
          tabCreationIds.push(item.creation_id);
        }
        
      }
      if (this.state.activateRestrictionsCMJN) {
        if (tabTopQuadri.length > (this.state.nbCmjnDifferents as number) || tabQuadriluxe.length > (this.state.nbCmjnDifferents as number) ||
          tabBroderie.length > (this.state.nbCmjnDifferents as number) || tabSerigraphie.length > (this.state.nbCmjnDifferents as number) ||
          tabSublimation.length > (this.state.nbCmjnDifferents as number)) {
          this.setState({
            nbrCmjnTopquadri: tabTopQuadri.length,
            nbrCmjnQuadriluxe: tabQuadriluxe.length,
            nbrCmjnBroderie: tabBroderie.length,
            nbrCmjnSericoat: tabSerigraphie.length,
            nbrCmjnSublimation: tabSublimation.length,
            allowOrder: false,
          });
        } else {
          this.setState({
            nbrCmjnTopquadri: tabTopQuadri.length,
            nbrCmjnQuadriluxe: tabQuadriluxe.length,
            nbrCmjnBroderie: tabBroderie.length,
            nbrCmjnSericoat: tabSerigraphie.length,
            nbrCmjnSublimation: tabSublimation.length,
            allowOrder: true,
          });
        }
      }
      const allowCreations = !(this.state.activateRestrictionsCreations && tabCreationIds.length > Number(this.state.nbCreationsDifferentes));
      let allowCreationsQtyControle = allowCreations;
      let minQtyToAdd = 0;
      if(this.state.nbCreationsDifferentesAvecControleQty && this.state.ratioQtyNbCreationsDifferentes) {
        allowCreationsQtyControle =  allowCreations && (tabCreationIds.length < this.state.nbCreationsDifferentesAvecControleQty || this.state.cart.quantite_globale >= (tabCreationIds.length * this.state.ratioQtyNbCreationsDifferentes));
        minQtyToAdd = (tabCreationIds.length * this.state.ratioQtyNbCreationsDifferentes) - this.state.cart.quantite_globale > 0 ? (tabCreationIds.length * this.state.ratioQtyNbCreationsDifferentes) - this.state.cart.quantite_globale : 0 ;
      }
      this.setState({
        allowCreations: allowCreations,
        allowCreationsQtyControle:allowCreationsQtyControle,
        minQtyToAdd: minQtyToAdd
      });
    }
  }

  render() {
    const cartNotEmpty = this.state.cart && typeof this.state.cart.items !== 'undefined' && this.state.cart.items.length > 0;
    const renderMessagePanierVide = () => {
      if (this.state.cart && !cartNotEmpty) {
        return (
          <div className="containerCartEmpty">
            { ref != 'DT' ? (
            <h1 style={{ fontSize: 'inherit' }}>{this.props.textsContent?.CART_EMPTY_TEXT}</h1>
              ) : (
              <div className="emptyCartStr" style={{ fontSize: 'inherit' }}>{this.props.textsContent?.CART_EMPTY_TEXT}</div>
              )}
          </div>
        );
      }
    };

    const renderCartTitle = () => {
      if (this.state.cart && ref != 'DT' && ref != 'MT' && ref != 'TH' ) {
        return (
          <h1 className="titleCategorie robotoBold font18 flex-grow-1">{this.props.textsContent?.CART_TITLE}</h1>
        );
      }
    };

    const renderCartItemQty = () => {
      if (this.state.cart && cartNotEmpty) {
        let nbArticles = this.state.cart.quantite_globale;
        if (ref === 'DT') {
          const sumReducer = (previousValue: number, currentValue: number): number => previousValue + currentValue;
          nbArticles = this.state.cart.items.map((item) => parseInt(item.quantite.toString())).reduce(sumReducer, 0);
        }

        return (
          <div>
            {this.props.textsContent?.CART_TOTAL_QUANTITY}
            <span className="font-weight-bold">{nbArticles}</span>
          </div>
        );
      }
    };
    const ref = getShopRefInStorage();
    const renderCartDetails = () => {


      if (this.state.cart) {
        return (
          <div id="containerCartDetails" className="row mt-3 mb-2 mx-0">
            {ref !== 'MT' ? (
              <RenderOptionsCart
                validerDroits={this.state.validerDroits !== undefined && this.state.validerDroits}
                montantOptions={this.state.cart.montants_options}
                garantie={this.state.cart.garantie}
                onValiderDroits={this.onValiderDroits}
              />
            ) : (
              <div className="col-md-7 col-lg-8 d-none d-lg-block p-0">&nbsp;</div>
            )}
            <RenderMontantsCart
              cart={this.state.cart}
              montants_transport={this.state.cart.montants_transport}
              montants={this.state.cart.montants}
              montantsOptions={this.state.cart.montants_options}
              remises={this.state.cart.remises}
              francoAtteint={this.state.francoAtteint}
              isModeHT={this.state.isModeHT}
              enabledFeatureOrderDelayType={this.state.enabledFeatureOrderDelayType}
            />
          </div>
        );
      }
    };

    const renderTextMaintenance = () => {
      const defineText = () => {
        if (this.state.activateMaintenance || this.state.activateMaintenanceSite) {
          return this.state.textMaintenance;
        }  if (this.state.activateRestrictionsCMJN == 1 && !this.state.allowOrder ) {
          return this.state.textNotAllowOrder ;
        } if (!this.state.allowSerigraphie) {
          return this.state.textMinSericoat;
        } if (!this.state.allowCreations) {
          return this.props.textsContent?.CART_CREATIONS_LIMIT_ERROR;
        }
        if(!this.state.allowCreationsQtyControle && this.state.minQtyToAdd && this.state.minQtyToAdd > 0 && this.state.cart) {
           return msgQtyMin();
        }
        if (this.state.maxLinesInCart) {
          return this.props.textsContent?.CART_LINES_LIMIT_ERROR;
        }
      };

      if (this.state.activateMaintenance || !this.state.allowOrder || this.state.activateMaintenanceSite || !this.state.allowSerigraphie || !this.state.allowCreations || (!this.state.allowCreationsQtyControle && this.state.minQtyToAdd && this.state.minQtyToAdd > 0) || this.state.maxLinesInCart) {
        const classDanger = !this.state.allowSerigraphie || !this.state.allowCreations || !this.state.allowCreationsQtyControle ? 'alert-danger' : '';
        return (
          <div className={"alert alert-warning col-lg-12 text-center mt1 white-space-pre-wrap "+classDanger} id="box-warning">
            <Icons icon="warning" size={25} color="#333" />&nbsp;
            {defineText()}
          </div>
        );
      }
    };

    const msgQtyMin = () => {
       const needQtyMin = this.state.cart?.quantite_globale + this.state.minQtyToAdd;
          const qtyMinMsg = this.props.textsContent?.['CART_QTY_MIN_RESTRICTIONS_ERROR']
          ?.replace('  ', ' ' + needQtyMin.toString() + ' ') ?? '';
          return qtyMinMsg;
    }

    const renderOrderButton = () => {
      const ref = getShopRefInStorage();

      const defineText = () => {
        if (this.state.activateMaintenance || this.state.activateMaintenanceSite) {
          return this.state.textMaintenance;
        }
        if(!this.state.allowSerigraphie) {
          return this.state.textMinSericoat;
        }
        if(!this.state.allowCreations) {
          return this.props.textsContent?.CART_CREATIONS_LIMIT_ERROR;
        }
        if(!this.state.allowCreationsQtyControle && this.state.minQtyToAdd && this.state.minQtyToAdd > 0 && this.state.cart) {
          return msgQtyMin();
        }
        return this.state.textNotAllowOrder;
      };

      if (this.state.activateMaintenance || !this.state.allowOrder || this.state.activateMaintenanceSite  || !this.state.allowSerigraphie || !this.state.allowCreations || (!this.state.allowCreationsQtyControle && this.state.minQtyToAdd && this.state.minQtyToAdd > 0) || this.state.maxLinesInCart) {
        return (
          <button title={defineText()}
                  className="btnSubmitCart pl-6 pr-6 font18 border-0 text-center rounded font-weight-bold text-black-50 order-1 order-md-2"
                  style={{ cursor: 'not-allowed' }} onClick={this._colorBoxWarning}>{this.props.textsContent?.['CART_BTN_ORDERING']}</button>
        );
      }

      let classes = "btnSubmitCart pl-6 pr-6 font18 border-0 text-white text-center rounded font-weight-bold bg-primary order-1 order-md-2";
      if (ref === 'DG') {
        classes = "buttonPrimary px-5 py-2 reset-button btnSubmitCart  order-1 order-md-2";
      }

      const usePaypalV2 = getShopInfosInStorage().paypal_v2;
      if (ref !== 'ME' || (ref == 'ME' && this.state.validerDroits)) {
        let customerId = null;
        if (sessionStorage.getItem('customerStruct')) {
          customerId = JSON.parse(sessionStorage.getItem('customerStruct') as string)['idClient'];
        }
        return (
          <>
            <button
              className={classes}
              disabled={!this.state.blacklistError.valid}
              onClick={this.onCommander}
            >
              {this.props.textsContent?.['CART_BTN_ORDERING']}
            </button>

            <div className="d-flex justify-content-end w-100 order-2 order-md-2">
              <div className="blocPaypalExpress mt-0 mt-md-2">
                {this.state.paypalExpressEnable && customerId == null && this.state.blacklistError.valid &&
                    <div className="d-flex flex-column flex-md-row align-items-center" style={{ width: '243px' }}>
                        <div className="mr-md-3 text-black-50"> {this.props.textsContent?.['CART_OR']}</div>
                        <div className="flex-grow-1 my-2 my-lg-0">
                          {usePaypalV2
                            ? <PaypalCheckoutV2 onPaymentApproved={this.handleOnPaymentApproved} cartId={this.state.cart?.id} onStockError={this.displayStockError}/>
                            : <PaypalCheckout onPaymentApproved={this.handleOnPaymentApproved} cartId={this.state.cart?.id} onStockError={this.displayStockError}/>
                          }
                        </div>
                    </div>
                }
              </div>
            </div>
          </>
        );
      }

      return (
        <button title="Veuillez valider la mise en page du mug avant de poursuivre"
                className="btnSubmitCart pl-6 pr-6 font18 border-0 text-center rounded font-weight-bold text-black-50 bg-grey240 order-1 order-md-2"
                style={{ cursor: 'not-allowed' }}
                onClick={this.surbrillanceDroits}>Commander</button>
      );
    };

    const renderClearCartContainer = () => {
      // const ref = getShopRefInStorage();
      // let linkOrder = '/order';
      if (this.state.cart) {
        return (
          <div className={'d-flex align-items-center justify-content-between mb-5 flex-wrap col-lg-12 col-xl-12 pl-md-0 px-0 px-md-3 '}>
            {renderTextMaintenance()}
              <RenderShareCart cartId={this.state.cart.id} cart={this.state.cart} />
            {renderOrderButton()}
          </div>
        );
      }
    };

    const renderCartTitleAndQty = () => {
      if (this.state.cart) {
        return (
          <div className="d-flex align-items-end mt-3">
            {renderCartTitle()}
            {renderCartItemQty()}
          </div>
        );
      }
    };

    const renderDeliveryDate = () => {
      const { activateMaintenance, cart, shippingDay } = this.state;
      if (!activateMaintenance) {
        const asterix = (cart && cart.montants_transport && cart?.montants_transport as number == 0) ? '*' : '';

        let shippingDayStr = null;
        if (shippingDay) {
          const optionsMax: Intl.DateTimeFormatOptions = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
          let defaultLang = 'fr';
          const i18nLangStr = localStorage.getItem('i18nLang');
          const i18nLang = i18nLangStr !== null ? JSON.parse(i18nLangStr) : null;

          if (i18nLang !== null) {
            defaultLang = i18nLang.lang.toLowerCase();
          }

          const timestamp = cart?.commande_lente ? shippingDay.timestamp_max : shippingDay.timestamp_min;
          shippingDayStr = new Date(timestamp * 1000).toLocaleDateString(defaultLang, optionsMax);

          if(shippingDay == "Invalid Date") {
            shippingDayStr = cart?.commande_lente ? shippingDay.max : shippingDay.min;
          }
        }

        return (
          <>
            {shippingDayStr &&
            <div className="text-center text-md-right font16 mt-md-4 mb-0 mb-md-2 mt-md-0 col-lg-12 dateLivraison">
              <Icons icon="local_shipping" size={25} color="#333" />&nbsp;
              {this.props.textsContent?.['CART_DELIVERY_MIN_TEXT']} <span className="font-weight-bold">{shippingDayStr}</span><sup>{asterix}</sup>
            </div>
            }
          </>
        );
      }
    };

    const renderAvailabilityConditions = () => {
      if (this.state.cart?.montants_transport as number == 0 && !this.state.activateMaintenance &&
        !this.state.activateMaintenanceSite) {
        return (
          <p className="text-center text-md-right font-italic text-black-50 small grey infosLivraison col-lg-12 mb-0 mb-md-2">
            <sup>*</sup>{this.props.textsContent?.['CART_DELIVERY_EXPRESS_INFO']}
          </p>
        );
      }
    };

    const renderContentCart = () => {
      if (this.state.cart && cartNotEmpty) {
        return (
          <div>
            <RenderLegendCart />
            <RenderItemsCart
              cartItems={this.state.cart.items}
              problemeSericoat={this.state.itemProblemeSerigraphie}
              cartId={this.state.cart.id}
              stockErrors={this.state.stockErrors}
              blacklistError={this.state.blacklistError}
              isModeHT={this.state.isModeHT}
            />
            {renderCartDetails()}
            {!this.state.enabledFeatureOrderDelayType && renderDeliveryDate()}
            {!this.state.enabledFeatureOrderDelayType && renderAvailabilityConditions()}
            {renderClearCartContainer()}
            {(!this.state.countryDelivery || this.state.countryDelivery ==='FR') &&
            <div className="row align-items-center flexReducFranco col-lg-12 col-xl-12">
                <RenderFrancoPort items={this.state.cart.items} franco={this.state.franco} francoAtteint={this.state.francoAtteint} francoNonAtteintRestant={this.state.francoNonAtteintRestant} />
            </div>
            }
          </div>
        );
      }
    };

    return (
      <>
        {this.state.cart && !this.state.applyIsProgress && (
          <>
            <div id="cartApp" className={'position-relative font14 main p-4'}>
              {renderCartTitleAndQty()}
              {renderContentCart()}
              {renderMessagePanierVide()}
            </div>
            {(this.state.cart && !cartNotEmpty) && (
              <div className="text-center containerCartEmpty pa0 ma0">
                {getShopInfosInStorage().Ref == 'TO' && (
                  <img className="img-responsive display-inline" src="images/interface/panier-vide.jpg" alt="" />
                )}
              </div>
            )}
          </>
        ) || (
          <div className="text-center" style={{ marginTop: '100px', marginBottom: '100px' }}>
            <div>
              <span className="loader loader-quart-8">
                <img className={'pl-0'} src="/order/images/ic_shopping_cart.svg" />
              </span>
              <div className="textLoader">{this.props.textsContent?.['CART_LOADING_TEXT']}</div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default WithTranslation(CartApp, 'CART_TUNNEL');
